import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

import { getFilm } from '../api'

Vue.use(Vuex)

const state = {
  panels: {
    left: {
      visible: false,
      content: 'events' // valid values are 'events' and 'contact'
    },
    right: false
  },

  films: [],

  events: {
    past: [],
    upcoming: []
  },

  news: '',
  contact: '',
  
  preloader: {
    visible: false,
    percentage: 0
  },

  filmContentVisible: false
}

const mutations = {
  mergeState: (state, mergeState) => {
    _.merge(state, mergeState)
  },

  setPanelVisibleLeft: (state, value) => {
    state.panels.left.visible = value
  },
  setPanelContentLeft: (state, value) => {
    state.panels.left.content = value
  },
  setPanelVisibleRight: (state, value) => {
    state.panels.right = value
  },
  storeFilm: (state, value) => {
    state.films = _.map(state.films, film => film.number === value.number ? value : film)
  },

  setPreloaderVisible: (state, value) => {
    state.preloader.visible = value
  },
  setPreloaderPercentage: (state, value) => {
    state.preloader.percentage = value
  },

  setFilmContentVisible: (state, value) => {
    state.filmContentVisible = value
  }
}

const actions = {
  loadFilm: (context, slug) => {
    return getFilm(slug)
      .then(response => {
        context.commit('storeFilm', response.data)
      })
  }
}

const getters = {

}

const storeInstance = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})

export default storeInstance
